function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 1093,
  height: 922
}, React.createElement("rect", {
  width: 1092.83,
  height: 921.278,
  transform: "matrix(1 0 0 -1 0.0849609 921.278)",
  fill: "#C4C4C4"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask0)"
}, React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M602.892 177.996H507.448V261.509H602.892V177.996Z",
  fill: "#2A7771"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M488.155 82.5522H622.182C624.72 82.5522 626.751 84.6922 626.751 87.3672V197.042C626.751 199.717 624.72 201.857 622.182 201.857H488.155C485.616 201.857 483.585 199.717 483.585 197.042V87.3672C483.585 84.6922 485.616 82.5522 488.155 82.5522Z",
  fill: "#3CA19D"
}), React.createElement("path", {
  d: "M238.552 261.454L197.257 302.761L254.201 359.689L295.496 318.382L238.552 261.454Z",
  fill: "#2A7771"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M138.777 264.49L200.315 202.952C201.775 201.491 204.174 201.491 205.739 202.952L271.24 268.453C272.7 269.913 272.7 272.312 271.24 273.772L209.702 335.31C208.242 336.771 205.843 336.771 204.278 335.31L138.777 269.809C137.212 268.453 137.212 266.054 138.777 264.49Z",
  fill: "#3CA19D"
}), React.createElement("path", {
  d: "M874.576 261.486L817.64 318.422L858.941 359.723L915.877 302.787L874.576 261.486Z",
  fill: "#2A7771"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M912.892 202.952L974.43 264.49C975.891 265.95 975.891 268.349 974.43 269.913L908.929 335.415C907.469 336.875 905.07 336.875 903.505 335.415L841.967 273.877C840.507 272.417 840.507 270.018 841.967 268.453L907.469 202.952C909.033 201.491 911.432 201.491 912.892 202.952Z",
  fill: "#3CA19D"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M553.145 226.889C813.062 226.889 1023.89 437.714 1023.89 697.632C1023.89 957.55 813.213 1168.38 553.145 1168.38C293.227 1168.38 82.4014 957.7 82.4014 697.632C82.4014 437.714 293.227 226.889 553.145 226.889Z",
  fill: "#2A7771"
}), React.createElement("path", {
  d: "M552.972 1131.78C794.992 1131.78 991.188 935.583 991.188 693.563C991.188 451.544 794.992 255.348 552.972 255.348C310.952 255.348 114.756 451.544 114.756 693.563C114.756 935.583 310.952 1131.78 552.972 1131.78Z",
  fill: "white"
}), React.createElement("path", {
  d: "M223.997 440.094L209.569 459.952L248.553 488.277L262.982 468.42L223.997 440.094Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M199.176 475.844L186.903 497.101L228.635 521.195L240.908 499.938L199.176 475.844Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M178.188 514.039L168.198 536.459L212.213 556.072L222.204 533.651L178.188 514.039Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M161.56 554.201L153.961 577.542L199.784 592.461L207.383 569.12L161.56 554.201Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M149.028 595.98L143.916 619.988L191.049 630.026L196.162 606.017L149.028 595.98Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M140.976 638.695L138.418 663.108L186.346 668.13L188.904 643.716L140.976 638.695Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M185.556 682.106H137.368V706.653H185.556V682.106Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M186.267 720.655L138.339 725.676L140.897 750.089L188.825 745.068L186.267 720.655Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M191.085 758.833L143.951 768.871L149.064 792.88L196.197 782.842L191.085 758.833Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M199.726 796.35L153.903 811.27L161.503 834.61L207.325 819.691L199.726 796.35Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M212.356 832.648L168.34 852.261L178.331 874.681L222.346 855.068L212.356 832.648Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M228.643 867.627L186.926 891.75L199.214 913L240.931 888.876L228.643 867.627Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M248.554 900.488L209.574 928.818L224.004 948.674L262.984 920.344L248.554 900.488Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M857.752 900.493L843.309 920.341L882.275 948.695L896.718 928.847L857.752 900.493Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M877.611 867.641L865.333 888.896L907.059 913L919.337 891.745L877.611 867.641Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M893.891 832.644L883.9 855.064L927.916 874.677L937.906 852.257L893.891 832.644Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M906.533 796.353L898.948 819.699L944.78 834.59L952.365 811.244L906.533 796.353Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M915.195 758.827L910.101 782.838L957.239 792.837L962.333 768.826L915.195 758.827Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M919.957 720.623L917.399 745.036L965.328 750.057L967.886 725.644L919.957 720.623Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M968.924 682.106H920.735V706.653H968.924V682.106Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M965.446 638.716L917.518 643.737L920.075 668.151L968.004 663.13L965.446 638.716Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M957.223 595.902L910.084 605.901L915.178 629.912L962.316 619.913L957.223 595.902Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M944.855 554.153L899.023 569.043L906.608 592.389L952.44 577.498L944.855 554.153Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M927.924 514.085L883.908 533.698L893.898 556.119L937.914 536.506L927.924 514.085Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M906.93 475.84L865.189 499.915L877.453 521.177L919.194 497.102L906.93 475.84Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M882.198 440.033L843.233 468.383L857.673 488.231L896.639 459.881L882.198 440.033Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M565.343 278.526H540.797V326.715H565.343V278.526Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M521.798 279.635L497.387 282.207L502.437 330.131L526.848 327.558L521.798 279.635Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M478.741 285.057L454.733 290.168L464.766 337.301L488.774 332.191L478.741 285.057Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M436.401 295.163L413.056 302.748L427.946 348.58L451.292 340.996L436.401 295.163Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M395.125 309.526L372.705 319.517L392.317 363.532L414.738 353.542L395.125 309.526Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M355.845 328.194L334.6 340.489L358.738 382.197L379.982 369.901L355.845 328.194Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M318.581 350.817L298.726 365.25L327.061 404.23L346.916 389.797L318.581 350.817Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M284.106 377.222L265.858 393.641L298.092 429.464L316.339 413.045L284.106 377.222Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M252.304 407.094L235.871 425.327L271.665 457.589L288.099 439.357L252.304 407.094Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M853.819 406.94L818.029 439.207L834.465 457.437L870.255 425.17L853.819 406.94Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M822.194 377.198L789.965 413.026L808.215 429.443L840.444 393.614L822.194 377.198Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M787.644 350.841L759.295 389.807L779.143 404.247L807.492 365.282L787.644 350.841Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M750.299 328.176L726.162 369.883L747.406 382.178L771.544 340.471L750.299 328.176Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M711.071 309.569L691.468 353.59L713.891 363.575L733.494 319.555L711.071 309.569Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M669.954 295.11L655.063 340.942L678.409 348.527L693.299 302.695L669.954 295.11Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M627.642 285.118L617.609 332.251L641.617 337.361L651.65 290.228L627.642 285.118Z",
  fill: "#B9D0FE"
}), React.createElement("path", {
  d: "M584.381 279.569L579.331 327.492L603.742 330.065L608.792 282.141L584.381 279.569Z",
  fill: "#B9D0FE"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  x: 54.0908,
  y: 22.2378,
  width: 1000.97,
  height: 1145.99,
  fill: "white"
})));

var SvgTimerStart = function SvgTimerStart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 1093,
    height: 922,
    viewBox: "0 0 1093 922",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTimerStart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timer_start.7f911553.svg";
export { ForwardRef as ReactComponent };